/* istanbul ignore file */
import './utils/basePathSetup'
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { AppEntryPoint } from './AppEntryPoint/AppEntryPoint'
import './index.scss'
import { appSettings } from './appConfig/appsettings'

const container = document.getElementById(appSettings.rootId) as HTMLElement
const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <AppEntryPoint />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
